// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_asset_study.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { DerivedData_3DModel, DerivedData_Image, DerivedData_Video, File } from "./dto_asset_common_pb.js";

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_CBCT
 */
export const AssetContent_Study_CBCT = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_CBCT",
  () => [
    { no: 1, name: "DICOMFiles", kind: "message", T: File, repeated: true },
    { no: 2, name: "CBCTArchive", kind: "message", T: File },
    { no: 3, name: "Metadata", kind: "message", T: AssetContent_Study_CBCT_CBCT_Metadata },
    { no: 4, name: "SeriesUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_CBCT.CBCT_Metadata
 */
export const AssetContent_Study_CBCT_CBCT_Metadata = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_CBCT.CBCT_Metadata",
  () => [
    { no: 12, name: "StudyTime", kind: "message", T: Timestamp },
    { no: 2, name: "InternalStudyUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "InternalSeriesUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "InternalInstanceUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "ScanUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "Manufacturer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "ManufacturerModelName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "SliceThickness", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "FOV", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "VoxelSize", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 11, name: "Exposure", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "AssetContent_Study_CBCT_CBCT_Metadata"},
);

/**
 * AssetContent_Study_CBCT_DCCT represents new custom CBCT study format.
 *
 * See https://gitlab.diagnocat.dev/research/prototype-diagnokit-rs for more details of
 * DCCT format and conversion process. It the link is not accessible, contact research
 * team for the access.
 *
 * @generated from message com.diagnocat.model.AssetContent_Study_CBCT_DCCT
 */
export const AssetContent_Study_CBCT_DCCT = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_CBCT_DCCT",
  () => [
    { no: 1, name: "Volume", kind: "message", T: File },
    { no: 2, name: "Metadata", kind: "message", T: AssetContent_Study_CBCT_DCCT_SanitizedMetadata },
    { no: 3, name: "RawMetadata", kind: "message", T: File },
  ],
);

/**
 * SanitizedMetadata contains a minimal subset of DICOM attributes required for
 * downstream processing and analytics.
 *
 * **Each field MUST be named after the corresponding DICOM tag name.**
 *
 * This message MUST be derived from `RawMetadata` by extracting these attributes from
 * the sanitized DICOM header (no other source). The only patient-related attributes in
 * this message are `PatientSex`, `PatientAge`, and `AcquisitionDateTime`.
 *
 * The producer MUST populate all non-optional fields with present and valid values.
 * Optionality reflects producer guarantees/capabilities and does not strictly model
 * DICOM type requirements; consult https://dicom.innolitics.com/ciods when deciding
 * which attributes can be treated as required.
 *
 * @generated from message com.diagnocat.model.AssetContent_Study_CBCT_DCCT.SanitizedMetadata
 */
export const AssetContent_Study_CBCT_DCCT_SanitizedMetadata = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_CBCT_DCCT.SanitizedMetadata",
  () => [
    { no: 1, name: "Manufacturer", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ManufacturerModelName", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "SpacingBetweenSlices", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "PixelSpacing", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 5, name: "NumberOfFrames", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "Rows", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "Columns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "SeriesInstanceUID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "PatientSex", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 10, name: "PatientAge", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 11, name: "AcquisitionDateTime", kind: "message", T: Timestamp, opt: true },
    { no: 12, name: "KVP", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 13, name: "XRayTubeCurrentInmA", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 14, name: "ExposureInmAs", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
  {localName: "AssetContent_Study_CBCT_DCCT_SanitizedMetadata"},
);

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_IOS_Meshes
 */
export const AssetContent_Study_IOS_Meshes = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_IOS_Meshes",
  () => [
    { no: 1, name: "Jaws", kind: "message", T: File, repeated: true },
    { no: 100, name: "Derived", kind: "message", T: DerivedData_3DModel },
  ],
);

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_MeshModel
 */
export const AssetContent_Study_MeshModel = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_MeshModel",
  () => [
    { no: 1, name: "Geometry", kind: "message", T: File },
    { no: 2, name: "MTL", kind: "message", T: File, opt: true },
    { no: 3, name: "Textures", kind: "message", T: File, repeated: true },
  ],
);

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_Panoramic_XRay
 */
export const AssetContent_Study_Panoramic_XRay = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_Panoramic_XRay",
  () => [
    { no: 1, name: "PanoramaImage", kind: "message", T: File },
    { no: 100, name: "Derived", kind: "message", T: DerivedData_Image },
  ],
);

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_Intraoral_XRay
 */
export const AssetContent_Study_Intraoral_XRay = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_Intraoral_XRay",
  () => [
    { no: 1, name: "Image", kind: "message", T: File },
    { no: 2, name: "Derived", kind: "message", T: DerivedData_Image },
  ],
);

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_Dental_Photo
 */
export const AssetContent_Study_Dental_Photo = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_Dental_Photo",
  () => [
    { no: 1, name: "Image", kind: "message", T: File },
    { no: 2, name: "Derived", kind: "message", T: DerivedData_Image },
  ],
);

/**
 * @generated from message com.diagnocat.model.AssetContent_Study_Dental_Video
 */
export const AssetContent_Study_Dental_Video = proto3.makeMessageType(
  "com.diagnocat.model.AssetContent_Study_Dental_Video",
  () => [
    { no: 1, name: "Video", kind: "message", T: File },
    { no: 2, name: "Derived", kind: "message", T: DerivedData_Video },
  ],
);

